module.exports = __webpack_public_path__ + "quotezone-ui/img/totally-money-logo.3a8df658.svg";